'use strict';

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import GroupedDiscountCodeRow from '@/Lists/Rows/GroupedDiscountCodeRow'
import Dashboard              from '@/Lists/Dashboard'

import SearchBar from '@Pure/SearchBar'
import Link      from '@Pure/Link'

const DASHBOARD = 'DiscountCodesByRefList';

const { app } = window;

const header =
[
	{
		label: 'Nom produit',
		name: 'product_name',
		sortable: false
	},
	{
		label: 'Référence produit',
		name: 'price_ref',
		sortable: false
	},
	{
		label: 'Utilisés',
		name: 'code',
		sortable: false
	},
	{
		label: 'Restants',
		name: 'code',
		sortable: false
	},
	{
		label: '',
		name: '_detail',
		sortable: false
	}
];

const fields = header.map(data => data.name);

const fields_with_timeout = ['searched'];

export default PageWrapper(function GroupedCodesDashboardPage (props)
{
	const storage_filters =
	{
		searched: window.localStorage.getItem(DASHBOARD + '.searched') || ''
	};

	const search_timeout = useRef();

	const [dashboard_key, setDashboardKey] = useState(0);

	const [instant_filters, setInstantFilters] = useState({ ...storage_filters });

	const handleChange = useCallback(function ({ value, e, name })
	{
		if (e === null && fields_with_timeout.includes(name) === false) return;

	// Prevent on mount trigger
		if (e === null && fields_with_timeout.includes(name)) return;

		window.localStorage.setItem(DASHBOARD + '.' + name, value);

		setInstantFilters(function (filters)
		{
			return { ...filters, [name]: value };
		});

		if (fields_with_timeout.includes(name) === false) return;

		if (search_timeout.current)
		{
			window.clearTimeout(search_timeout.current);
		}

		search_timeout.current = window.setTimeout(function ()
		{
			search_timeout.current = undefined;

			setDelayedFilters(function (delayed_filters)
			{
				return { ...delayed_filters, [name]: value };
			});
		},
		320);
	},
	[]);

	const [delayed_filters, setDelayedFilters] = useState({ ...storage_filters });

	const handleSearchChange = useCallback(function (value, data={ }, e)
	{
		handleChange({ value: value || '', name: data?.name, e });
	},
	[handleChange]);

	const filters = useMemo(function ()
	{
		const filters =
		{
			searched: delayed_filters.searched
		};

		if (instant_filters.id) filters.id = instant_filters.id;

		return filters;
	},
	[instant_filters, delayed_filters]);

	return (
		<Layout history={ props.history } page_title="Codes promos par référence">

			<div className="page-content">

				<div className="o-grid-4 u-content-between u-items-center
					u-margin-bottom-30">

					<div className="o-grid__item">
						<SearchBar hide_btn={ true }
							placeholder="Ref. produit (exacte)"
							handleChange={ handleSearchChange }
							value={ instant_filters.searched }
							name="searched"
							className="c-searchbar c-searchbar--full-width"
						/>
					</div>

					<div className="o-grid__item u-flex" />
					<div className="o-grid__item u-flex" />

					<div className="o-grid__item u-flex u-content-end
						u-items-center">
						<Link href="/import-codes-promo"
							className="c-btn c-btn--add u-no-margin-top">
							Importer des codes
						</Link>
					</div>

				</div>

				<div className="o-content">

					<Dashboard model="DiscountCodeByRef" items-per-page={ 50 }
						url="/dashboard/discount-codes-by-ref" filters={ filters }
						header={ header } fields={ fields }
						disable-sort={ filters.searched ? true : false }
						component={ GroupedDiscountCodeRow }
						condensed
						key={ String(dashboard_key || 0) }
					/>

				</div>

			</div> { /* /page-content */ }

		</Layout>
	);
});